var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{pre:true,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","fill":"none"}},[_c('path',{pre:true,attrs:{"stroke":"currentColor","stroke-width":"1.3","stroke-linecap":"round","stroke-linejoin":"round","d":"m1.5 4.75 5.5 5.5 5.5-5.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }